<span v-translate="translateOptions"></span>